import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID, COGNITO_REDIRECT_URI } from "./config";

const cognitoAuthConfig = {
    authority: COGNITO_AUTHORITY,
    client_id: COGNITO_CLIENT_ID,
    redirect_uri: COGNITO_REDIRECT_URI,
    response_type: "code",
    scope: "phone openid email profile",
  };  

  export default cognitoAuthConfig;